import moment from "moment";
import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";

const ResearchCard = ({ research }) => {
  const [postDate, setPostDate] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (!research?.date) return;
    const currentDate = moment();
    const postMoment = moment(research.date);
    const postDiffM = currentDate.diff(postMoment, "minutes");
    const postDiffH = currentDate.diff(postMoment, "hours");
    const postDiffD = currentDate.diff(postMoment, "days");

    if (postDiffD > 0) {
      setPostDate(`${postDiffD} ${postDiffD === 1 ? "day" : "days"} ago`);
    } else if (postDiffH > 0) {
      setPostDate(`${postDiffH} ${postDiffH === 1 ? "hour" : "hours"} ago`);
    } else {
      setPostDate(`${postDiffM} ${postDiffM === 1 ? "minute" : "minutes"} ago`);
    }
  }, [research?.date]);

  const rawDes = research?.research || "";
  const displayDes = isExpanded
    ? rawDes
    : rawDes.length > 300
    ? rawDes.substring(0, 300) + "..."
    : rawDes;

  return (
    <div className="bg-white border border-gray-100 rounded-3xl p-6 sm:p-8 shadow-sm hover:shadow-md transition-all duration-300">
      {/* Title */}
      <h2 className="font-heading text-xl sm:text-2xl font-extrabold text-gray-900 mb-2">
        {research?.researchTitle}
      </h2>

      {/* Meta details */}
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-gray-400 mb-6 font-medium">
        <span className="flex items-center gap-1.5">
          <Icon icon="solar:user-bold" className="w-3.5 h-3.5 text-indigo-500" />
          By {research?.researchersName || "CareSee Researcher"}
        </span>
        <span className="text-gray-300">|</span>
        <span className="flex items-center gap-1.5">
          <Icon icon="solar:calendar-bold" className="w-3.5 h-3.5 text-indigo-500" />
          {postDate || "Recently Published"}
        </span>
      </div>

      {/* Description */}
      <div
        className="text-sm text-gray-600 leading-relaxed text-justify mb-6 prose max-w-none"
        dangerouslySetInnerHTML={{ __html: displayDes }}
      />

      {/* Action Footer */}
      <div className="flex flex-wrap items-center justify-between gap-4 pt-5 border-t border-gray-100/60">
        <div className="flex items-center gap-3">
          {rawDes.length > 300 && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="inline-flex items-center gap-1.5 text-xs font-bold text-indigo-600 hover:text-indigo-700 uppercase tracking-wider transition-colors"
            >
              {isExpanded ? "Read Less" : "Read More"}
              <Icon
                icon={isExpanded ? "solar:alt-arrow-up-linear" : "solar:alt-arrow-down-linear"}
                className="w-4 h-4"
              />
            </button>
          )}
        </div>

        {research?.importantUrl && (
          <a
            href={research.importantUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 px-4 py-2 bg-indigo-50 hover:bg-indigo-100 text-indigo-600 text-xs font-bold rounded-xl transition-all uppercase tracking-wider"
          >
            Read Full Study
            <Icon icon="solar:arrow-right-linear" className="w-3.5 h-3.5" />
          </a>
        )}
      </div>
    </div>
  );
};

export default ResearchCard;
